import waitForTrue from './promise/waitForTrue';
import sleep from './promise/sleep';

export default {
  waitForTrue,
  sleep,
};
